import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@views/LoginView.vue'
import HomeView from '@views/HomeView.vue'
import AccessView from '@views/AccessView.vue'
import CostQueryView from '@views/CostQueryView.vue'
import QueryHistoryView from '@views/QueryHistoryView.vue'
import BatchQueryView from '@views/BatchQueryView.vue'



export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: '/home',
      name: 'home',
      component: CostQueryView
    },
    {
      path: '/access',
      name: 'access',
      component: AccessView
    },
    {
      path: '/cost-query',
      name: 'cost-query',
      component: CostQueryView
    },
    {
      path: '/query-history',
      name: 'query-history',
      component: QueryHistoryView
    },
    {
      path: '/batch-query',
      name: 'batch-query',
      component: BatchQueryView
    },
    {
      path: '/',
      name: 'homepage',
      component: CostQueryView
    },


  ]
})
